import "./AIResultsStatus.scss";

import { useState } from "react";

import type { AILienAnalysis } from "../LienTypes";
import AIResultsModal from "./AIResultsModal";

type AIResultsStatusProps = {
  aiAnalyses: Record<string, AILienAnalysis> | null;
  selectedAppealLevel: string;
  lienId: number;
};

const AIResultsStatus = ({
  aiAnalyses,
  selectedAppealLevel,
  lienId,
}: AIResultsStatusProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  if (!aiAnalyses) {
    return null;
  }

  const currentAnalysis = aiAnalyses[selectedAppealLevel];

  if (!currentAnalysis) {
    return null;
  }

  const hasMismatch = currentAnalysis.payment_amount_mismatch;

  const handleClick = () => {
    setIsModalOpen(true);
  };

  if (hasMismatch) {
    return (
      <>
        <div
          className="ai-results-status ai-results-status--error"
          onClick={handleClick}
        >
          <span className="material-icons ai-results-status__icon">error</span>
          <span className="ai-results-status__message">
            AI Results Mismatch
          </span>
        </div>
        <AIResultsModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          analysis={currentAnalysis}
          lienId={lienId}
          levelOfAppeal={selectedAppealLevel}
        />
      </>
    );
  }

  return (
    <>
      <div
        className="ai-results-status ai-results-status--success"
        onClick={handleClick}
      >
        <span className="material-icons ai-results-status__icon">
          check_circle
        </span>
        <span className="ai-results-status__message">OCR Integrity</span>
      </div>
      <AIResultsModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        analysis={currentAnalysis}
        lienId={lienId}
        levelOfAppeal={selectedAppealLevel}
      />
    </>
  );
};

export default AIResultsStatus;
